export default "__VITE_ASSET__DPPUqDIC__"